import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-progress-text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, "0%", -1)
const _hoisted_3 = { class: "center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, "100%", -1)

import {onBeforeUnmount, onMounted, ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    modelValue: {}
  },
  setup(__props: any) {

const props = __props

const outer = ref<HTMLDivElement>()
const inner = ref<HTMLDivElement>()

const update = () => {
  if (inner.value && outer.value) {
    const fullWidth = outer.value.getBoundingClientRect().width
    const width = Math.round(fullWidth * props.modelValue / 100)
    inner.value.style.width = `${width}px`
  }
}

onMounted(() => update())

watch(() => props.modelValue, update)

window.addEventListener('resize', update)

onBeforeUnmount(() => window.removeEventListener('resize', update))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "app-progress-bar",
      ref_key: "outer",
      ref: outer
    }, [
      _createElementVNode("div", {
        class: "inner",
        ref_key: "inner",
        ref: inner
      }, null, 512)
    ], 512),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.modelValue) + "%", 1),
      _hoisted_4
    ])
  ]))
}
}

})